import {     
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild, } from "@angular/core";
import { MatSlideToggle , MatSlideToggleChange} from "@angular/material/slide-toggle";
import { FacturaDTO } from "app/main/apps/shared/interfaces/factura.interface";
import { FacturaService } from "app/main/apps/shared/services/rest/factura.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { Subscription } from "rxjs";


@Component({
    selector: "app-factura-oocc",
    templateUrl: "./factura-oocc.component.html",
    styleUrls: ["./factura-oocc.component.scss"],
})
export class FacturaOoccComponent implements OnInit {
    @Input() origen: string;
    @Input() factura: FacturaDTO;
    @Output() toggleEstadoFacturaEvent: EventEmitter<FacturaDTO> = new EventEmitter();
    @ViewChild("checkActivacion", { static: false })
    slideActivacion: MatSlideToggle;

    subscripciones: Subscription;
    esSupervisor:boolean=false;
    constructor(
        private _facturaSrvc: FacturaService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.subscripciones = new Subscription();
    }

    toggleEstadoFactura(factura) {
        this.toggleEstadoFacturaEvent.emit(factura);
    }

    evaluaActivacion() {
        //if (this.origen === 'factura'){
            this.slideActivacion.checked = { ...this.factura }.pagada;
        //}
    }

    ngOnInit(): void {
        //console.log('llego a cargar la factura');
        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();
        //console.log(`Es supervisor = ${this.esSupervisor}`);
    }

    toggleActivacion(event: MatSlideToggleChange) {
        this.toggleEstadoFacturaEvent.emit(this.factura);
    }


    ngAfterViewInit() {
        //console.log(this.slideActivacion);
        setTimeout(() => {
            if (this._menuUsuarioSrvc.esSupervisor()) {
                this.evaluaActivacion();
            }
        });

        this.subscripciones.add(
            this._facturaSrvc.facturaChanged$
                //.pipe(distinctUntilChanged())
                .subscribe((resp) => {
                    this.factura = resp;
                    this.evaluaActivacion();
                })
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
